
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.19 3.122L33.914 2l-.936.673a24.108 24.108 0 01-10.041 4.189c-5.863 1.121-9.106 2.58-11.95 5.36-8.745 8.526-5.377 24.457-5.227 25.13l.137.648.661-.037c10.79-.499 18.661-3.964 23.401-10.297 7.622-10.197 4.366-23.958 4.23-24.544zm-5.49 23.61c-4.028 5.372-10.552 8.513-19.384 9.423 7.372-5.884 18.05-19.16 20.482-24.22l-1.41-.673c-1.134 2.356-4.09 6.52-7.646 10.87a13.232 13.232 0 01-2.67-6.57l-1.546.187a14.763 14.763 0 003.206 7.604 133.923 133.923 0 01-4.117 4.662 13.267 13.267 0 01-2.52-6.357l-1.546.187a14.772 14.772 0 002.994 7.33c-2.632 2.754-5.24 5.16-7.435 6.718-.586-3.714-1.871-15.868 4.99-22.55 2.632-2.567 5.55-3.864 11.139-4.936 3.43-.573 6.76-1.87 9.68-3.777.574 3.453 1.759 14.136-4.216 22.101z"}})])
          )
        }
      }
    